[
     {
        "display": "true",
        "ui_columnname": "Action",
        "db_columnname": "",
        "datatype": "char",
        "mappingkey": "",
        "dropdown": "NO",
        "isdefault": "false",
        "isrequired": "false",
        "isFormField": "false",
        "disabled": false,
        "value": "",
        "maxlength": 1,
        "dropdowntype": "",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "Venue MPID",
        "db_columnname": "venueMPID",
        "datatype": "String",
        "mappingkey": "venueMPID",
        "dropdown": "NO",
        "isdefault": "false",
        "isrequired": "true",
        "isFormField": "true",
        "disabled": false,
        "value": "",
        "maxlength": 7,
        "dropdowntype": "",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "Venue Name",
        "db_columnname": "venueName",
        "datatype": "String",
        "mappingkey": "venueName",
        "dropdown": "NO",
        "isdefault": "false",
        "isrequired": "true",
        "isFormField": "true",
        "disabled": false,
        "value": "",
        "maxlength": 80,
        "dropdowntype": "",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "Venue Firm Name",
        "db_columnname": "venueFirmName",
        "datatype": "String",
        "mappingkey": "venueFirmName",
        "dropdown": "NO",
        "isdefault": "false",
        "isrequired": "true",
        "isFormField": "true",
        "disabled": false,
        "value": "",
        "maxlength": 80,
        "dropdowntype": "",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "Venue Type",
        "db_columnname": "venueType",
        "datatype": "String",
        "mappingkey": "venueType",
        "dropdown": "YES",
        "isdefault": "false",
        "isrequired": "true",
        "isFormField": "true",
        "disabled": false,
        "value": "",
        "maxlength": 10,
        "dropdowntype": "singleselect",
        "dropdownvalue": [
            { "label": "PRV", "value": "PRV", "description": "PRV" },
            { "label": "EV/SRV", "value": "EV/SRV", "description": "EV/SRV" }]
    },
    {
        "display": "true",
        "ui_columnname": "MIC Code",
        "db_columnname": "micCode",
        "datatype": "String",
        "mappingkey": "micCode",
        "dropdown": "NO",
        "isdefault": "false",
        "isrequired": "true",
        "isFormField": "true",
        "disabled": false,
        "value": "",
        "maxlength": 7,
        "dropdowntype": "",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "Approved",
        "db_columnname": "isApproved",
        "datatype": "Boolean",
        "mappingkey": "isApproved",
        "dropdown": "NO",
        "isdefault": "false",
        "isrequired": "false",
        "isFormField": "true",
        "disabled": false,
        "value": "",
        "maxlength": 4,
        "dropdowntype": "",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "Approved By",
        "db_columnname": "approvedBy",
        "datatype": "String",
        "mappingkey": "approvedBy",
        "dropdown": "NO",
        "isdefault": "false",
        "isrequired": "false",
        "isFormField": "false",
        "disabled": true,
        "value": "",
        "maxlength": 4,
        "dropdowntype": "",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "Approved Date",
        "db_columnname": "approvedDate",
        "datatype": "String",
        "mappingkey": "approvedDate",
        "dropdown": "NO",
        "isdefault": "false",
        "isrequired": "false",
        "isFormField": "false",
        "disabled": true,
        "value": "",
        "maxlength": 4,
        "dropdowntype": "",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "Created Date",
        "db_columnname": "createdDate",
        "datatype": "Date",
        "mappingkey": "createdDate",
        "dropdown": "NO",
        "isdefault": "false",
        "isrequired": "false",
        "isFormField": "false",
        "disabled": true,
        "value": "",
        "dropdowntype": "",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "Updated Date",
        "db_columnname": "updatedDate",
        "datatype": "Date",
        "mappingkey": "updatedDate",
        "dropdown": "NO",
        "isdefault": "false",
        "isrequired": "false",
        "isFormField": "false",
        "disabled": true,
        "value": "",
        "dropdowntype": "",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "Created User",
        "db_columnname": "createUser",
        "datatype": "String",
        "mappingkey": "createUser",
        "dropdown": "NO",
        "isdefault": "false",
        "isrequired": "false",
        "isFormField": "false",
        "disabled": true,
        "value": "",
        "dropdowntype": "",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "Updated User",
        "db_columnname": "lastUpdatedBy",
        "datatype": "String",
        "mappingkey": "lastUpdatedBy",
        "dropdown": "NO",
        "isdefault": "false",
        "isrequired": "false",
        "isFormField": "false",
        "disabled": true,
        "value": "",
        "dropdowntype": "",
        "dropdownvalue": ""
    }
]